import { axiosInstance } from './instance';

const addTokenToHeaders = () => {
    const token = localStorage.getItem('token');

    if(token){
        axiosInstance.defaults.headers.common['token'] = token;
    }
}

export {addTokenToHeaders};
